import React, { useEffect, useState } from 'react';
import { FieldValues, Path } from 'react-hook-form';
import RadioList, { FilterListItem } from '../../RadioList';
import { cameraService } from '../../../../services/central-api/cameras';

function DownloadActingBodyList<
    TFieldValues extends FieldValues,
    TName extends Path<TFieldValues>,
>({ name }: { name: TName; }) {
    const [items, setItems] = useState<FilterListItem[]>([]);
    const [isLoading, setIsLoading] = useState(true);

    async function getActingBodies() {
        try {
            const bodies = await cameraService.getActingBodies();
            setItems(bodies.map(body => ({ label: body.name, value: body.id })));
        } catch (err) {
            console.error(err);
        } finally {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        getActingBodies();
    }, []);

    return <RadioList name={name} items={items} clearValue={0} isLoading={isLoading} />;
}

DownloadActingBodyList.getCount = (value: number) => value !== 0 ? 1 : 0;

export default DownloadActingBodyList;
